import { RestricaoConta } from 'enuns/RestricaoConta';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@material-ui/core';
import { CircleCheckIcon, ColaboradorIcon, MaletaIcon } from 'components/Icons';
import { AssembleiaContaAssessor } from 'models/AssembleiaContaAssessor';
import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useStyle from './style';
interface Props {
  idEvento: string;
  dadosAssociados: AssembleiaContaAssessor[];
}

export default function ({ idEvento, dadosAssociados }: Props) {
  const { t } = useTranslation();
  const classes = useStyle();

  const temColaborador = useMemo<boolean>(() => {
    return !!dadosAssociados.find(it => it.restricao === RestricaoConta.Colaborador);
  }, [dadosAssociados])

  const temColaboradorPJ = useMemo<boolean>(() => {
    return !!dadosAssociados.find(it => it.restricao === RestricaoConta.ColaboradorPJ);
  }, [dadosAssociados])

  const temColaboradorMei = useMemo<boolean>(() => {
    return !!dadosAssociados.find(it => it.restricao === RestricaoConta.ColaboradorMei);
  }, [dadosAssociados])

  const Headers = useMemo(() => [
    t('canalVoz.cooperativa'),
    t('canalVoz.agencia'),
    t('canalVoz.conta'),
    t('canalVoz.nome'),
    t('canalVoz.presenca')

  ], [t]);

  return (
    <Fragment>
      <div className={classes.legendas}>
        {temColaborador && (
          <Typography className={classes.legendaText} component="p">
            <ColaboradorIcon className={classes.legendaIcon} />
            {t(`canalVoz.legendaColaborador`)}
          </Typography>
        )}
        {temColaboradorPJ && (
          <Typography className={classes.legendaText} component="p">
            <MaletaIcon className={classes.legendaIcon} />
            {t(`canalVoz.legendaColaboradorPJ`)}
          </Typography>
        )}
        {temColaboradorMei && (
          <Typography className={classes.legendaText} component="p">
            <MaletaIcon className={classes.legendaIcon} />
            {t(`canalVoz.legendaColaboradorMei`)}
          </Typography>
        )}
      </div>
      <TableContainer className={classes.root}>
        <Table>
          <TableHead className={classes.box}>
            <TableRow>
              
              <TableCell  className={[classes.title, classes.leftCell].join(' ')} align={"left"}>
                {Headers[0]}
              </TableCell>
              <TableCell  className={[classes.title, classes.leftCell].join(' ')} align={"left"}>
                {Headers[1]}
              </TableCell>
              <TableCell  className={[classes.title, classes.leftCell].join(' ')} align={"left"}>
                {Headers[2]}
              </TableCell>
              <TableCell  className={[classes.title, classes.middleCell].join(' ')} align={"left"}>
                {Headers[3]}
              </TableCell>
              <TableCell  className={[classes.title, classes.rightCell].join(' ')} align={"left"} padding={'none'}>
                {Headers[4]}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.box}>
            {dadosAssociados.map((row: AssembleiaContaAssessor, index: number) => (
              <TableRow key={row.numeroConta}>
                <TableCell className={classes.data} align="left" >
                  {row.codigoCooperativa}
                </TableCell>
                <TableCell className={classes.data} align="left" >
                  {row.codigoAgencia}
                </TableCell>
                <TableCell className={classes.data} align="left" >
                  {row.numeroConta}
                </TableCell>
                <TableCell className={classes.data} align="left" >
                  {row.restricao === RestricaoConta.Colaborador && (
                    <Tooltip title={t(`canalVoz.legendaColaborador`).toString()}>
                      <ColaboradorIcon className={classes.tableIcon} />
                    </Tooltip>
                  )}
                  {row.restricao === RestricaoConta.ColaboradorPJ && (
                    <Tooltip title={t(`canalVoz.legendaColaboradorPJ`).toString()}>
                      <MaletaIcon className={classes.tableIcon} />
                    </Tooltip>
                  )}
                  {row.restricao === RestricaoConta.ColaboradorMei && (
                    <Tooltip title={t(`canalVoz.legendaColaboradorMei`).toString()}>
                      <MaletaIcon className={classes.tableIcon} />
                    </Tooltip>
                  )}
                  {row.nome}
                </TableCell>
                <TableCell className={classes.rightCell} align="left" padding={'none'}>
                  <div className={classes.confirmField}>
                    {
                      row.presente ?
                        row.origem ? t('canalVoz.canalVoz') : t('canalVoz.presenteOnline')
                      : t('canalVoz.semPresenca')
                    }
                    {row.presente && <CircleCheckIcon className={classes.navIcon} />}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>

        </Table>
      </TableContainer>
    </Fragment>
  );
}
